import { connect } from 'react-redux'
import React from 'react'
import {Link} from 'react-static'
import {Button} from 'reactstrap'
import Spinner from '../components/Spinner'
import { signout } from '../actions/account'

const SignOut = ({ authUser, isFetching, handleSignout }) => (
  <React.Fragment>
    <div className="row">
      <div className="col-sm-12">
        <div className="page-title-box">
          <h4 className="page-title">Abmeldung</h4>
          <div className="clearfix"/>
        </div>
      </div>
    </div>

    <div className="row">
      <div className="col-sm-12 col-xs-12">
        {isFetching
          ?
          <Spinner/>
          :
          <div className="card-box">
            {authUser
              ?
              <React.Fragment>
                <h5>Hallo {authUser.email}!</h5>
                <p>Wollen Sie wirklich sich abmelden?</p>
                <Button color="primary" onClick={handleSignout}>Abmelden</Button>
              </React.Fragment>
              :
              <div className="text-success">
                Sie sind nicht angemeldet
                <br/><br/>
                <Link to='/signin' className="btn btn-primary">Erneut Anmelden</Link>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </React.Fragment>
)

export default connect(
  state => ({
    authUser: state.account.authUser,
    isFetching: state.account.isFetching
  }),
  dispatch => ({
    handleSignout: () => dispatch(signout())
  })
)(SignOut)



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/SignOut.js